export default __webpack_public_path__ + "static/media/Group 3381@2x.0813255a.png";